import React, { Component } from 'react';
import PropTypes from 'prop-types';
import analytics from 'lmn-gtm-analytics';
import throttle from 'lodash/throttle';
import Video from '../Video';
import './VideoBackgroundSlider.scss';
import Carousel from '../Carousel';
import Slide from './Slide';
import eventOptionsFactory from '../../../events/options-factory';
import { prismicImage } from 'src/common/utils/prismic-image';

const invalidatingEvents = ['scroll', 'wheel', 'resize'];

const eventOptions = eventOptionsFactory({
  passive: true
});

/* eslint-disable no-unused-vars */
const handleThumbnailClick = (index) => {
  analytics.track('Testimonial Carousel', {
    category: 'Homepage',
    label: index,
  });
};
/* eslint-enable no-unused-vars */

class VideoBackgroundSlider extends Component {
  static propTypes = {
    primary: PropTypes.shape({
      videoFallbackColour: PropTypes.string,
      videoPoster: PropTypes.object.isRequired,
      videoUrl: PropTypes.string.isRequired,
    }),
    items: PropTypes.array.isRequired,
  };
  state = {
    isOnScreen: false,
    isAboutToEnterScreen: false,
  };

  constructor(props) {
    super(props);

    this.onRef = this.onRef.bind(this);
    this.requestRedraw = this.requestRedraw.bind(this);
    this.redraw = this.redraw.bind(this);
    this.debouncedRequestRedraw = throttle(this.requestRedraw, 250);

    this._raf = false;
    this._rafId = null;
    this._$el = null;
  }

  componentDidMount() {
    invalidatingEvents.forEach(eventName => {
      document.addEventListener(eventName, this.debouncedRequestRedraw, eventOptions);
      window.addEventListener(eventName, this.debouncedRequestRedraw, eventOptions);
    });
    this.requestRedraw();
  }

  componentWillUnmount() {
    invalidatingEvents.forEach(eventName => {
      document.removeEventListener(eventName, this.debouncedRequestRedraw, eventOptions);
      window.removeEventListener(eventName, this.debouncedRequestRedraw, eventOptions);
    });

    cancelAnimationFrame(this._rafId);
    this._rafId = null;
    this._raf = false;
    this._$el = null;
  }

  requestRedraw() {
    if (!this._raf) {
      this._raf = true;
      this._rafId = requestAnimationFrame(this.redraw);
    }
  }

  redraw() {
    if (!this._raf) {
      return;
    }
    this._raf = false;

    if (this._$el) {
      const top = this._$el.offsetTop;

      if (!this.state.isAboutToEnterScreen && window.pageYOffset >= top - window.innerHeight) {
        this.setState(() => ({
          isAboutToEnterScreen: true
        }));
      }

      if (!this.state.isOnScreen && window.pageYOffset >= top - window.innerHeight / 2) {
        this.setState(() => ({
          isOnScreen: true,
        }));
      }

    }
  }

  onRef($el) {
    if (this._$el !== $el) {
      this._$el = $el;
      this.requestRedraw();
    }
  }

  render() {
    return (
      <section
        ref={this.onRef}
        className="video-background-slider"
        style={{ backgroundColor: this.props.primary.videoFallbackColour }}>
        <div className="video-background-slider-video-wrapper">
          {this.state.isAboutToEnterScreen &&
          <Video
            className="video-background-slider-video"
            replayOnEnd
            isOnScreen={this.state.isOnScreen}
            src={this.props.primary.videoUrl}
            poster={prismicImage(this.props.primary.videoPoster)}
          />}
        </div>
        <div className="video-background-slider-content">
          <div className="video-background-slider-carousel">
            <Carousel group="video-background-carousel" disableNavigation>
              {this.props.items.map((item, i) => (
                <div
                  key={`carousel-slide-${i}`}
                  className="video-background-carousel-slide" >
                  <Slide quote={item.quote} citation={item.citation} />
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      </section>
    );
  }
}

export default VideoBackgroundSlider;



// WEBPACK FOOTER //
// ./src/client/js/view/components/VideoBackgroundSlider/VideoBackgroundSlider.js